@let actions = toast().actions;
@let body = toast().body;
@let delay = toast().delay;
@let header = toast().header;
@let hideClose = toast().hideClose;
@let progress = autoHide.progress();
@let showProgress = toast().showProgress;
@let showProgressbar = showProgress && delay > 0;

<!-- Header -->
@if (header != null) {
  <div class="toast-header">
    @if (isTemplate(header)) {
      <ng-template [ngTemplateOutlet]="header" [ngTemplateOutletContext]="{ toast: toast() }"></ng-template>
    } @else {
      <span class="me-auto">{{ $any(header) | portalTranslate }}</span>

      @if (hideClose !== true) {
        <button class="btn-close" (click)="hide()" aria-label="Close" type="button"></button>
      }
    }
  </div>
}

<div class="toast-body">
  <!-- Body -->
  @if (isTemplate(body)) {
    <ng-template [ngTemplateOutlet]="body"></ng-template>
  } @else {
    <div class="d-flex align-items-center">
      @if (header == null) {
        <span class="me-1">
          <i class="fa-fw state-icon" [class]="iconClasses()"></i>
        </span>
      }

      <span [ngClass]="{ 'me-4': showProgress && delay === 0 }">{{ body | portalTranslate }}</span>

      @if (showProgress && delay === 0) {
        <i class="far fa-circle-notch fa-spin ms-auto"></i>
      }
    </div>
  }

  <!-- Actions -->
  @if (actions?.length > 0) {
    <div class="portal-toast__actions">
      @for (action of actions; track action.label) {
        <button class="btn btn-sm" [ngClass]="'btn-' + action.variant" (click)="invokeAction(action)">
          {{ action.label | portalTranslate }}
        </button>
      }
    </div>
  }

  <!-- Progressbar -->
  @if (showProgressbar) {
    <div class="progress">
      <div
        class="progress-bar"
        [attr.aria-valuenow]="progress"
        [style]="'width: ' + progress + '%'"
        aria-valuemax="100"
        aria-valuemin="0"
        role="progressbar"
      ></div>
    </div>
  }
</div>
